import { datadogLogs } from "@datadog/browser-logs";
import { datadogRum } from "@datadog/browser-rum";
import { reactPlugin } from "@datadog/browser-rum-react";
import Cookies from "js-cookie";

import { CookieKeys } from "@/utils/cookie-keys";

const DATADOG_LOGS_SESSION_SAMPLE_RATE = 5;
const DATADOG_RUM_SESSION_SAMPLE_RATE = 5;
const DATADOG_RUM_SESSION_REPLAY_SAMPLE_RATE = 0;

// Just make this condition true of you want to test DataDog during development
if (process.env.NODE_ENV === "production") {
  const publicKey = Cookies.get(CookieKeys.publicKey) || "guest";
  const user = {
    id: publicKey,
    publicKey,
  };

  console.log("Initializing DataDog Client Logging");

  datadogLogs.init({
    forwardErrorsToLogs: true,
    sessionSampleRate: DATADOG_LOGS_SESSION_SAMPLE_RATE,
    clientToken: process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN,
    service: process.env.NEXT_PUBLIC_DATADOG_SERVICE_NAME,
    env: process.env.NEXT_PUBLIC_DATADOG_ENV,
  });

  datadogLogs.onReady(() => {
    datadogLogs.setUser(user);
  });

  console.log("Initializing DataDog RUM");

  datadogRum.init({
    applicationId: process.env.NEXT_PUBLIC_DATADOG_APP_ID,
    clientToken: process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN,
    site: process.env.NEXT_PUBLIC_DATADOG_SITE,
    service: process.env.NEXT_PUBLIC_DATADOG_SERVICE_NAME,
    env: process.env.NEXT_PUBLIC_DATADOG_ENV,

    // Specify a version number to identify the deployed version of your application in Datadog
    // version: '1.0.0',
    sessionSampleRate: DATADOG_RUM_SESSION_SAMPLE_RATE,
    sessionReplaySampleRate: DATADOG_RUM_SESSION_REPLAY_SAMPLE_RATE,
    defaultPrivacyLevel: "mask-user-input",
    plugins: [reactPlugin({ router: false })],
  });

  datadogRum.onReady(() => {
    datadogRum.setUser(user);
  });

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  globalThis.dd = datadogLogs;
} else {
  const getProxy = () => {
    return new Proxy(function () {}, {
      get() {
        return getProxy();
      },
    });
  };

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  globalThis.dd = getProxy();
}
